import { SlideAction, useSlideLayout, ViewMode } from '@gripp/shared-ui';
import { useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { CustomMutationForm } from '../../shared/components/forms/mutationForm';
import { CREATE_WORKSPACE_WITH_OWNER } from '../operations/createWorkspaceWithOwner';
import { CreateWorkspaceForm } from './createWorkspaceForm';
import { Workspaces } from './workspaces';

const dataTransformer = (data: {
  name: string;
  type: string;
  ownerFirstName: string;
  ownerLastName: string;
  ownerEmail: string;
  ownerPhone: string;
  routineIds: string[];
}) => ({
  name: data.name,
  type: data.type,
  owner: {
    first: data.ownerFirstName,
    last: data.ownerLastName,
  },
  ownerEmail: data.ownerEmail.toLowerCase(),
  ownerPhone: data.ownerPhone,
  routineIds: data.routineIds ?? [],
});

export const WorkspaceNewPage = () => {
  const onCompleteFnRef = useRef<(() => void) | undefined>(undefined);

  const rightColumn = {
    title: 'workspace.create.title',
    mainComponent: (
      <>
        <CustomMutationForm
          defaultValues={{
            name: '',
            ownerFirstName: '',
            ownerLastName: '',
            ownerEmail: '',
            routineIds: [],
          }}
          formComponent={CreateWorkspaceForm}
          modelName="workspace"
          mutationOperation={CREATE_WORKSPACE_WITH_OWNER}
          invalidateCache={true}
          onComplete={() => onCompleteFnRef.current?.()}
          dataTransformer={dataTransformer}
        />
        <BackHandlerRegistrar onCompleteFnRef={onCompleteFnRef} />
      </>
    ),
    showBackButton: true,
    disableScroll: true,
    onBackButtonPress: () => onCompleteFnRef.current?.(),
  };

  return <Workspaces rightColumn={rightColumn} viewMode={ViewMode.DUAL} />;
};

const BackHandlerRegistrar = ({
  onCompleteFnRef,
}: {
  onCompleteFnRef: React.MutableRefObject<(() => void) | undefined>;
}) => {
  const navigate = useNavigate();
  const { onSlideChange } = useSlideLayout();

  onCompleteFnRef.current = async () => {
    await onSlideChange(SlideAction.SINGLE);
    navigate('/workspaces');
  };

  return null;
};
